import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { HeaderComponent } from '../../../core/layout/header/header.component';
import { FooterComponent } from '../../../core/layout/footer/footer.component';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../../../core/services/auth.service';
import { GoogleLoginProvider, GoogleSigninButtonModule, SocialAuthService } from '@abacritt/angularx-social-login';


@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, RouterModule, HeaderComponent, FooterComponent, ReactiveFormsModule, GoogleSigninButtonModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  errorMessage: string = '';
  loading!: boolean;
  submitted!: boolean;
  authService = inject(AuthService);
  socialAuthService = inject(SocialAuthService);
  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private router: Router
  ) {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });
  }

  ngOnInit(): void { }
  ngAfterViewInit() {
    this.socialAuthService.authState.subscribe((user) => {
      this.getAccessToken();
    });
  }
  getAccessToken(): void {
    this.socialAuthService.getAccessToken(GoogleLoginProvider.PROVIDER_ID).then(accessToken => {
      this.authService.loginGoogleApi(accessToken).subscribe((res: any) => {
        this.router.navigate(['/']);
      });
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.loginForm.valid) {
      this.loading = true;
      this.authService.login(this.loginForm.value).subscribe({
        next: (response: any) => {
          this.loading = false;
          this.router.navigate(['/clients']);
        },
        error: (error) => {
          this.loading = false;
          this.errorMessage = 'Identifiants incorrects';
          console.error('Erreur de connexion:', error);
        }
      });
    }
  }

  loginWithGoogle() {
  }
  clearErrors() {
    this.errorMessage = '';
  }
}
